import { ActionType } from "../constants";
import { IAction, IState } from "../types";

export const initialState: IState = {
    isLoggedIn: false,
    loading: false,
    otpSent: localStorage.getItem("top")==="1"?true: false,
    error: {
        status: false,
        message: ""
    },
    payload: {
        url: "",
        title: ""
    },
    medium: "web",
    shared: false,
}

export const AppReducer = (initialState: IState, action: IAction): IState => {
    switch(action.type) {
        case ActionType.LOGIN:
            return {
                ...initialState,
                isLoggedIn: true,
                otpSent: false,
                loading: false
            }
        case ActionType.VERIFY_OTP:
            localStorage.setItem("otp", "1");
            return {
                ...initialState,
                otpSent: true,
                loading: false
            }
        case ActionType.ADD_URL:
            return {
                ...initialState,
                isLoggedIn: true,
                payload: {
                    url: action.payload.url,
                    title: action.payload.title,
                }
            }
        case ActionType.ERROR:
            return {
                ...initialState,
                error: {
                    status: true,
                    message: action.error.message,
                }
            }
        case ActionType.LOGOUT:
            return {
                ...initialState,
                isLoggedIn: false,
                otpSent: false,
                loading: false
            }
        case ActionType.LOADING:
            return {
                ...initialState,
                loading: true
            }
        case ActionType.NOT_LOADING:
            return {
                ...initialState,
                loading: false
            }
        case ActionType.SET_MEDIUM:
            return {
                ...initialState,
                medium: action.payload.type,
            }
        default:
            throw Error("No such action");
    }
}